document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.hero-carousel-track');
  if (!track) return;

  const slides = Array.from(track.children);
  const slideDuration = 7800;
  const overlayDuration = 2000;
  const transitionDuration = 800;

  let index = 0;
  let overlayTimeout;

 const getVisibleVideo = (slide) => {
  if (window.matchMedia('(max-width: 767px)').matches) {
    return slide.querySelector('.video-mobile');
  }
  if (window.matchMedia('(max-width: 1024px)').matches) {
    return slide.querySelector('.video-tablet');
  }
  return slide.querySelector('.video-desktop');
};


  const stopAllVideos = () => {
    slides.forEach(slide => {
      slide.classList.remove('hero-overlay-active');
      slide.querySelectorAll('video').forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    });
  };

  const playVisibleVideo = (slide) => {
    const video = getVisibleVideo(slide);
    if (!video) return;

    video.currentTime = 0;
    video.play().catch(() => {});
  };

  const goToSlide = () => {
    clearTimeout(overlayTimeout);
    stopAllVideos();

    const activeSlide = slides[index];

    // Move slide
    track.style.transform = `translateX(-${index * 100}%)`;

    // Play visible video AFTER transition
    setTimeout(() => {
      playVisibleVideo(activeSlide);
    }, transitionDuration);

    // Overlay in last second
    overlayTimeout = setTimeout(() => {
      if (activeSlide.querySelector('.hero-video-overlay')) {
        activeSlide.classList.add('hero-overlay-active');
      }
    }, slideDuration - overlayDuration);

    index = (index + 1) % slides.length;
  };

  goToSlide();
  setInterval(goToSlide, slideDuration);
});
